import { connect } from 'react-redux';
import Absence from '../../components/absence/absence';
import {
  fetchPlants,
  fetchAbsences,
  fetchNextAbsences,
} from './absence-actions';

const mapDispatchToProps = {
  fetchPlants,
  fetchAbsences,
  fetchMore: fetchNextAbsences,
};

const mapStateToProps = state => ({
  plants: state.absence.plants,
  serviceCenterId: state.serviceCenter.activeServiceCenter,
  isLoadingData: state.absence.isLoadingData,
  absences: state.absence.data,
  hasNext: state.absence.hasNext,
  totalDataCount: state.absence.totalDataCount,
  error: state.absence.error,
});

export default connect(mapStateToProps, mapDispatchToProps)(Absence);

